import { RJSFValidationError } from "@rjsf/utils";

/**
 * @name transformErrors
 * @description Transforms validation error messages to be more user-friendly
 * @param {RJSFValidationError[]} errors - Array of validation errors from RJSF
 * @returns {RJSFValidationError[]} Transformed errors with custom messages
 */
export const transformErrors = (
  errors: RJSFValidationError[]
): RJSFValidationError[] => {
  return errors.filter((error) => error.message && error.name).map((error) => {
    // Handle type errors
    if (error.name === "type") {
      const expectedType = error.params?.type;
      // expectedType may be a string or a string[] (JSON Schema type arrays),
      // or undefined when params is absent — guard so .includes() is never
      // called on undefined.
      if (typeof expectedType === "string" || Array.isArray(expectedType)) {
        if (expectedType.includes("integer")) {
          error.message = "Please enter a valid number";
        } else if (expectedType.includes("number")) {
          error.message = "Please enter a valid number";
        } else if (expectedType.includes("boolean")) {
          error.message = "Please select Yes or No";
        } else if (expectedType.includes("string")) {
          error.message = "Please enter text";
        }
      }
    }
    // Handle enum errors
    else if (error.name === "enum") {
      error.message = "Please select a valid option from the list";
    }
    // Handle required field errors
    else if (error.name === "required") {
      error.message = "This field is required";
    }
    // Handle pattern errors
    else if (error.name === "pattern") {
      error.message = "Please enter a value in the correct format";
    }
    // Handle minLength errors
    else if (error.name === "minLength") {
      const minLength = error.params?.limit;
      error.message =
        minLength === 1
          ? "This field cannot be empty"
          : `Please enter at least ${minLength} characters`;
    }
    // Handle maxLength errors
    else if (error.name === "maxLength") {
      error.message = `Please enter no more than ${error.params?.limit} characters`;
    }
    // Handle minimum value errors
    else if (error.name === "minimum") {
      error.message = `Value must be at least ${error.params?.limit}`;
    }
    // Handle maximum value errors
    else if (error.name === "maximum") {
      error.message = `Value must be no more than ${error.params?.limit}`;
    }
    // Handle format errors
    else if (error.name === "format") {
      const format = error.params?.format;
      if (format === "date" || format === "date-time") {
        error.message = "Please enter a valid date";
      } else if (format === "email") {
        error.message = "Please enter a valid email address";
      } else if (format === "uri") {
        error.message = "Please enter a valid URL";
      }
    }

    return error;
  });
};
